import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4be94c4&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=a4be94c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be94c4",
  null
  
)

export default component.exports